<template>
    <div class="payByMethod" v-if="paymentType.indexOf('WECHAT')<0" v-html="paymentContent.checkoutShape"></div>
    <div class="payment--container" v-else>
        <div class="payment--title">
            <div class="transition--message">
                <div class="message--title">
                    您正在使用微信即时到帐交易，付款后资金直接进入对方账户，若发生退款需联系收款方协商。
                   
                </div>
                <div class="order--info">
                    皇家加勒比国际游轮 订单号: {{bookingIds}}
                    <span class="collect">收款方: 皇家加勒比国际游轮</span>
                </div>
            </div>
            <div class="transition--price">
                <div class="price">
                    <span class="yuan">{{(totalAmount/100).toFixed(2)}}</span>元
                </div>
                
            </div>
        </div>
        <div class="payment">
            <!-- 微信支付 -->
            <div class="pay-weixin">
                <div class="p-w-hd">微信支付</div>
                <div class="scan--scan">
                    扫一扫付款(元)
                    <div class="price">{{(totalAmount/100).toFixed(2)}}</div>
                </div>
                <div class="p-w-bd" style="position:relative">
                    <div class="p-w-container">
                        <div class="p-w-box">
                            <div class="pw-box-hd">
                                <img id="weixinImageURL" :src="qrCodeUrl">
                            </div>
                            <div class="pw-box-ft">
                                <p>请使用微信扫一扫</p>
                                <p>扫描二维码支付</p>
                            </div>
                        </div>
                        <div class="p-w-sidebar"></div>
                    </div>
                </div>
            </div>
            <!-- 微信支付 end -->
        </div>
    </div>
</template>

<script>
import qrcode from 'qrcode'
import api from '@/api'
export default {
    name: "PayByMethod",
    props: {
        paymentContent: {
            type: Object
        },
        paymentType: {
            type: String
        },
        bookingIds: {
            type: String
        },
        totalAmount: {
            type: Number,
            default () {
                return 0
            }
        }
    },
    data () {
        return {
            qrCodeUrl: "",
            checkPaidInterval: null
        }
    },
    beforeMount () {
        // 如果没有预订参数，返回上一页
        if (!this.paymentContent || this.paymentContent == '' 
        || !this.paymentType || this.paymentType == '') {
            this.$router.go(-1)
        }
    },
    beforeDestroy () {
        if (this.checkPaidInterval) {
            clearInterval(this.checkPaidInterval)
        }
    },
    mounted () {
        
        switch(this.paymentType) {
            case 'ALIPAY': {
                this.alipayFormHandler()
                break
            }
            case 'UNIONPAY' : {
                this.unionPayHandler()
                break
            }
            case 'WECHATQRCODEPAY': {
                this.wechatQrCodeHandler()
                break
            }
            default: break
        }
    },
    
    methods: {
        alipayFormHandler () {
            const forms = document.getElementsByTagName('form')
            if (forms) {
                forms[0].submit()
            }
        },
        unionPayHandler () {
            const forms = document.getElementById('pay_form')
            if (forms) {
                forms.action = process.env.VUE_APP_UNION_PAY_URL
                forms.submit()
            }
        },
        async wechatQrCodeHandler () {
            if (this.paymentContent&&this.paymentContent.checkoutShape) {
                this.qrCodeUrl = await qrcode.toDataURL(this.paymentContent.checkoutShape)
                this.checkPaidInterval = setInterval(this.checkPaid, 2000)
            }
        },
        async checkPaid () {
            const { success, data } = await api.booking.checkPaid({
                paymentId: this.paymentContent.requestId
            })
            if (success && data) {
                if (this.checkPaidInterval) {
                    clearInterval(this.checkPaidInterval)
                }
                const self = this
                this.$alert.show("支付成功！", {
                    confirmCallBack: ()=> {
                        location.href = self.paySuccessUrl
                    }
                });
            }
        }
    },
    computed: {
        paySuccessUrl() {
            return `${process.env.VUE_APP_BASE_URL}${process.env.VUE_APP_PAY_SUCCESS_URL}?paymentId=${this.paymentContent.orderId}`
        }
    }
}
</script>

<style lang="less" scoped>
.payByMethod {
    display: none;
}

.payment--container {
    background: #f0f1f3;
    .payment--title {
        height: 82px;
        width: 990px;
        margin: 0 auto;
        .transition--message {
            float: left;
            height: 82px;
            width: 700px;
            overflow: hidden;
            .message--title {
                color: #333333;
                font-weight: 500;
                height: 41px;
                line-height: 61px;
                padding-left: 30px;
            }
            .order--info {
                color: #333333;
                font-size: 15px;
                font-weight: 600;
                height: 41px;
                line-height: 41px;
                padding-left: 30px;
                .collect {
                    font-weight: 500;
                    display: inline-block;
                    margin-left: 20px;
                }
            }
        }
        .transition--price {
            float: left;
            height: 82px;
            width: 290px;
            overflow: hidden;
            .price {
                color: #333333;
                height: 41px;
                font-weight: 500;
                text-align: right;
                line-height: 81px;
                padding-right: 30px;
                .yuan {
                    color: #e35d14;
                    font-size: 22px;
                    font-weight: 600;
                    display: inline-block;
                    margin-right: 3px;
                }
            }
        }
    }

    .payment {
        width: 990px;
        height: 511px;
        margin: 0 auto 0px;
        background-color: #fff;
        padding: 12px 30px 50px;
        -moz-box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 1px 25px rgba(0, 0, 0, 0.1);
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        -webkit-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
        .pay-weixin {
            zoom: 1;
            .p-w-hd {
                margin-bottom: 20px;
                font-size: 18px;
            }
            .scan--scan {
                text-align: center;
                .price {
                    color: #e35d14;
                    font-size: 22px;
                    font-weight: 600;
                    margin: 5px 0 10px;
                }
            }
            .p-w-bd {
                margin-bottom: 30px;
                .p-w-container {
                    width: 298px;
                    height: auto;
                    margin: 0 auto;
                    -moz-box-shadow: 0 0 20px rgba(0,0,0,.12);
                    -webkit-box-shadow: 0 0 20px rgba(0,0,0,.12);
                    box-shadow: 0 0 20px rgba(0,0,0,.12);
                    .p-w-box {
                        margin: 0 auto;
                        width: 300px;
                        .pw-box-hd {
                            margin-bottom: 20px;
                            border: 1px solid #ddd;
                            width: 298px;
                            height: 298px;
                            img {
                                width: 100%;
                                height: 100%;
                                position: relative;
                                top: 0%;
                                left: 0%;
                            }
                        }
                        .pw-box-ft {
                            height: 60px;
                            padding: 8px 0 8px 95px;
                            background:#061556;
                            p {
                                margin: 0;
                                font-size: 14px;
                                line-height: 22px;
                                color: #fff;
                                font-weight: 700;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>